<template>
    <div>
    <div class="page-header clear-filter"></div>
    <div class="section">
        <div class="container">
            
                <!-- product name and description section start -->
                        <div class="row">
                            <div class="col-lg-5 col-md-5 col-sm-5 text-center align-self-center">
                                 
                                <img v-bind:src="productImgUrl+ productsdetails['product_image_url']" :alt="productsdetails['url_name']" />
                                
                            </div>

                               <div class="col-lg-7 col-md-7 col-sm-7">

                                <h3 class="product__title">{{productsdetails["product_name"]}}</h3>
                                <div class="product-details-order-now-btn" v-if="productsdetails.status === 1">
                                    <div class="shop-single__controls">
                                        <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                                            <button mat-raised-button="" v-on:click="() => $router.push('https://www.doodhvale.com/order')" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"><span class="mat-button-wrapper">Order Now</span>
                                            <div class="mat-button-ripple mat-ripple" matripple=""></div>
                                            <div class="mat-button-focus-overlay"></div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                   <span></span>
                                </div>


                                <div >
                                    <p v-if="productsdetails.status != 1" class="product__shortdesc" >
                                        <i class="fa fa-times out-of-stock" aria-hidden="true" style="color:red; font-size: medium;"></i>
                                        <strong class="out-of-stock" style="color:red"> Out of stock</strong>
                                    </p>
                                    <p v-else class="product__shortdesc" >
                                        <i class="fa fa-check-square-o in-stock" aria-hidden="true" style="color:green;font-size: medium;"></i>
                                        <span class="in-stock"> In stock</span>
                                    </p>
                                </div>

                                <div >
                                    <div v-if="productsdetails.product_price_list[0].offer_status === 1">
                                        <p class="product__shortdesc discountedPrice">MRP: &#x20b9; {{productsdetails.product_price_list[0]["discounted_mrp"]}}.00</p>
                                    </div>
                                    <div v-else>
                                        <p class="product__shortdesc discountedPrice">MRP: &#x20b9; {{productsdetails.product_price_list[0]["mrp"]}}.00</p>
                                    </div>
                                </div>
                                
                                <p class="product__shortdesc">
                                    <b>Quantity: </b>{{productsdetails.product_price_list[0]["quantity"]}}{{productsdetails.product_price_list[0]["unit"]}}
                                </p>

                                <p class="product__shortdesc">
                                    <span>Brand Name: </span>{{productsdetails["brand_name"]}}
                                </p>

                                <p class="product__shortdesc">
                                    <span>Category: </span>{{productsdetails["cat_name"]}}
                                </p>

                                <p class="product__shortdesc" style="text-align: justify;">
                                    {{productsdetails["product_description"]}}.&nbsp;
                                </p>
                                <p class="product__description" style="text-align: justify;">
                                    
                                    {{productsdetails["prod_description"]}}
                                </p>
                            <table v-if="showNutritional" class="tg">
                        <thead>
                          <tr>
                            <th class="tg-62l6" colspan="2">Nutritional Information<br>Amount per 100g</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(value, name) in nutriTable" :key="name">
                            <td class="tg-0pky">{{name}}</td>
                            <td class="tg-0pky">{{value}}</td>
                          </tr>
                          
                        </tbody>
                        </table>

                    </div>
                            </div>
                
                <!-- product name and description section end -->

                
            
        </div>
    </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    name: 'product',
    // props: ['url'],
    data() {
    return {
        productsdetails: {},
        showNutritional: false,
        nutriTable: {},
        productUrlName: this.$route.params.url,
        apiUrl: 'https://doodhvale.in/dv/',
        productImgUrl: 'https://doodhvale.in',
        paneer: { "Energy": "289 kcal", "Energy from FAT": "225 g", "Energy": "289 kcal", "Total FAT": "25 g","Saturated FAT": "15 g", "Cholesterol": "66 mg","Carbohydrates": "2 g", "Added Sugar": "0 g","Protein": "14 g", "Calcium": "480 mg" },
         cowMilk: { "Energy": "68 kcal", "Milk FAT": "3.5 g", "Carbohydrates": "5 g","Milk Protein": "3.3 g", "Calcium": "110 mg" },
         lowFatCowMilk: { "Energy": "52 kcal", "Milk FAT": "1.5 g", "Carbohydrates": "5.4 g","Milk Protein": "3.4 g", "Calcium": "145 mg" },
         buffaloMilk: { "Energy": "90 kcal", "Milk FAT": "6.5 g", "Carbohydrates": "5.0 g","Milk Protein": "3.3 g", "Calcium": "135 mg" },
         dahi: { "Energy Value": "63 kcal","Protein": "3.5 g","Carbohydrates ": "5.0 g", "Sugar": "0.0 g", "Calcium": "150 mg", "FAT": "3.0 g","SNF": "8.5 g" },
    };
  },
  metaInfo() {
        return { 
            title: `${this.productsdetails.seo_prod_title}`,
            meta: [
                { name: 'description', content: this.productsdetails.seo_prod_desc },
                // OpenGraph data (Most widely used)
                { property: 'og:title', content: this.productsdetails.seo_prod_title},
                { property: 'og:site_name', content: 'Doodhvale'},
                { property: 'og:type', content: 'website'}, 
                { property: 'og:description', content: this.productsdetails.seo_prod_desc},
                {property: 'og:url', content: 'https://www.doodhvale.com/product/'+this.productsdetails.url_name},   
                // Twitter card
                {name: 'twitter:card', content: 'summary'},
                //{name: 'twitter:site', content: 'https://www.doodhvale.com/about'},
                {name: 'twitter:title', content: this.productsdetails.seo_prod_title},
                {name: 'twitter:description', content: this.productsdetails.seo_prod_desc},
                // Your twitter handle, if you have one.
                //{name: 'twitter:creator', content: '@alligatorio'}
                //{name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},
                //{name: 'robots', content: 'index,follow'} 
            ],
            link: [
                {rel: 'canonical', href: 'https://www.doodhvale.com/product/'+this.productsdetails.url_name}
            ]
        }
    },
  
  created() {
      //debugger
      //alert(this.$route.params.url)
      //console.log(this.$route)
      /* this.$router.onReady(() => {
          alert(this.$route.name)
      if (this.$route.name === 'product') {
        //this.doAThing()
      }
    }), */
   // this.productUrlName = this.$route.params.url
    this.getData()
  },
  /* computed: function () {
       alert(this.$route.params.url)
   },
   mounted: function () {
       alert(this.$route.params.url)
   },
   watch: {
      '$route' (to, from) {
        alert(this.$route.params.url)
        this.getData()
      }
    },
    // watch() { */
      /* this.$router.onReady(() => {
          alert(this.$route.name)
      if (this.$route.name === 'product') {
        //this.doAThing()
      }
    }), */
    //this.productUrlName = this.$route.params.url
    //this.getData()

   //},
  methods: {
    getData () {
        //alert(this.$route.params.url)
         
        this.productUrlName = this.$route.params.url
        let params = new URLSearchParams();
        params.append('product_name', this.productUrlName);
        axios({
            url: this.apiUrl + 'doodhvale/api/web/v3/products/product-details',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
        }).then(response => {
            this.productsdetails = response.data
            if(this.productsdetails.product_id == 151){
                this.showNutritional = true;
                this.nutriTable = this.lowFatCowMilk;
            }
            else if(this.productsdetails.product_id == 344 || this.productsdetails.product_id == 1 ){
                this.showNutritional = true;
                this.nutriTable = this.cowMilk;
            }
            else if(this.productsdetails.product_id == 345){
                this.showNutritional = true;
                this.nutriTable = this.buffaloMilk;
            }
            else if(this.productsdetails.product_id == 7){
                this.showNutritional = true;
                this.nutriTable = this.dahi;
            }
            else if(this.productsdetails.product_id == 110){
                this.showNutritional = true;
                this.nutriTable = this.paneer;
            }else{
                this.showNutritional = false;
                this.nutriTable = {}
            }
        })
    }
  }
  

}
</script>
<style type="text/css">
.tg  {border-collapse:collapse;border-spacing:0;width:100%;border-color: #000;color: #000;font-family: "Poppins Regular";}
.tg td{border-color:black;border-style:solid;border-width:1px;font-size:12px;
  overflow:hidden;padding:10px 15px;word-break:normal;}
.tg th{border-color:black;border-style:solid;border-width:1px;font-size:12px;overflow:hidden;padding:10px 15px;word-break:normal;}
.tg .tg-62l6{border-color:inherit;font-size:12px;font-weight:normal;text-align:center;vertical-align:top
  }
.tg .tg-0pky{border-color:inherit;text-align:left;vertical-align:top}
</style>